module.exports = __webpack_public_path__ + "img/街道白天.c96663e6.png";